import { render, staticRenderFns } from "./snack.vue?vue&type=template&id=d1ad185c"
import script from "./snack.vue?vue&type=script&lang=js"
export * from "./snack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports